import { UPLOAD_VEKTOR } from '../actions/actionTypes';

const initialState = {};

const uploadVectorReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_VEKTOR:
      return {
        data: payload,
      };
    default:
      return state;
  }
};

export default uploadVectorReducer;
